import React from 'react';
// Components
import ManageStoreBio from 'components/common/ManageStoreBio';

const ManageAthleteBio = (): JSX.Element => {
  return <ManageStoreBio />;
};

export default ManageAthleteBio;
